export default __webpack_public_path__ + "static/media/apple.32c0a422.svg";